// @flow
import * as React from 'react'

import './P.scss'

type Props = {
  children: React.Node,
}

export default class P extends React.Component<Props> {
  render = () => {
    return <div className="P">{this.props.children}</div>
  }
}
